import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Monitor, GraduationCap, Briefcase, Lightbulb, Target, ArrowRight } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ICON_MAP = { Monitor, GraduationCap, Briefcase, Lightbulb };

export default function ProgramsPage() {
  const [programs, setPrograms] = useState([]);

  useEffect(() => {
    axios.get(`${API}/programs`).then((r) => setPrograms(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="programs-page" className="pt-24">
      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="font-body text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-blue-400 mb-6">
            Nos Programmes
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-slate-50 mb-8 max-w-4xl leading-[1.1]">
            Des programmes concrets pour un impact reel
          </h1>
          <p className="font-body text-base md:text-lg font-light leading-relaxed text-slate-300 max-w-3xl">
            EDUCPEOPLE deploie quatre programmes complementaires pour accompagner les publics vulnerables vers l'autonomie numerique, la reussite educative et l'insertion professionnelle.
          </p>
        </div>
      </section>

      <div className="section-divider" />

      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {programs.map((prog) => {
              const IconComp = ICON_MAP[prog.icon] || Target;
              return (
                <Link
                  key={prog.slug}
                  to={`/programmes/${prog.slug}`}
                  data-testid={`program-link-${prog.slug}`}
                  className="group bg-slate-900/50 border border-white/10 rounded-3xl overflow-hidden hover:border-blue-500/50 transition-all duration-300 program-card-hover"
                >
                  <div className="relative h-56 overflow-hidden">
                    <img
                      src={prog.image_url}
                      alt={prog.title}
                      className="w-full h-full object-cover img-zoom opacity-60 group-hover:opacity-80 transition-opacity"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/40 to-transparent" />
                    <div className="absolute top-6 left-6">
                      <div className="w-12 h-12 rounded-xl bg-blue-500/20 backdrop-blur-sm flex items-center justify-center">
                        <IconComp className="w-6 h-6 text-blue-400" />
                      </div>
                    </div>
                  </div>
                  <div className="p-6 md:p-8">
                    <h2 className="font-heading text-2xl md:text-3xl font-light text-slate-50 mb-3 group-hover:text-blue-400 transition-colors">
                      {prog.title}
                    </h2>
                    <p className="font-body text-sm text-slate-400 leading-relaxed mb-4">
                      {prog.description}
                    </p>
                    <div className="flex items-center gap-2 text-blue-400 font-body text-sm font-medium">
                      Decouvrir le programme <ArrowRight className="w-4 h-4" />
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
